import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const createExternalProviderBatchRequest = createApiThunk<string, CreateExternalProviderBatchRequestBody>(
  "externalProviderBatchRequest/createExternalProviderBatchRequest",
  async (body, { extra: { studentRepository } }) => {
    return studentRepository!.createExternalProviderBatchRequest(body);
  },
);

export const resetCreateExternalProviderBatchRequest = createAction("externalProviderBatchRequest/resetCreateExternalProviderBatchRequest");
